import Vue from "vue";

export default {
	state: {
		familyRequirements: [],
		requirementsByFamily: []
	},
	mutations: {
		setFamilyRequirementsOnState(state, familyRequirements) {
			state.familyRequirements = mapFamilyRequirements(familyRequirements);
		},
		setRequirementsByIdFamilyOnState(state, requirementsByFamily) {
			state.requirementsByFamily = requirementsByFamily;
		},
		cleanRequirementsByFamily(state) {
			state.requirementsByFamily = [];
		}
	},
	actions: {
		getFamilyRequirement({ commit }, obj) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("familyRequirement/" + obj.id, obj.filter)
					.then((response) => {
						this.state.loading = false;
						commit("setFamilyRequirementsOnState", response.data.data);
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		deleteFamilyRequirement(_, obj) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.delete("familyRequirement", obj)
					.then((response) => {
						this.state.loading = false;
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		deleteFamilyByIdRequirement(_, id) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.delete("familyRequirement/idRequirement/" + id)
					.then((response) => {
						this.state.loading = false;
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		async newFamilyRequirement(_, familyRequirement) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.post("familyRequirement", familyRequirement).then((response) => {
					this.state.loading = false;
					resolve(response.data.data);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},

		editFamilyRequirement(_, familyRequirement) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.put("familyRequirement/" + familyRequirement.idFamilyRequirement, familyRequirement)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		getRequirementsByIdFamily({ commit }, idFamilies) {
			this.state.loading = true;
			let familylist = {
				idFamilies: idFamilies
			};
			return new Promise((resolve) => {
				Vue.prototype.$http.post("familyRequirement/listById", familylist).then((response) => {
					this.state.loading = false;
					commit("setRequirementsByIdFamilyOnState", response.data.data);
					resolve(response.data.data);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		getFullTreeListByIdFamily({ commit }, input) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("familyRequirement/fullTreeListById/", input)
					.then((response) => {
						commit("setRequirementsByIdFamilyOnState", response.data.data);
						commit("setSpecificRequirementsOnState", response.data.data.requirements);
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		checkFamilyByIdRequirement(_, id) {
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("familyRequirement/idRequirement/" + id)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		}
	},
	getters: {
		familyRequirements({ familyRequirements }) {
			return familyRequirements;
		},
		requirementsByFamily({ requirementsByFamily }) {
			return requirementsByFamily.requirements ? requirementsByFamily.requirements : [];
		}
	}
};

const mapFamilyRequirements = (familyRequirementFromBack) => {
	return familyRequirementFromBack.requirement ? familyRequirementFromBack.requirement : familyRequirementFromBack;
};
